import React, { Component } from 'react';
import Axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { Modal, Button, notification, Form, Input, Select, Tooltip } from 'antd';

import LS_SERVICE from '../../../utils/localStorage';
import DeleteIcon from '../../../assets/images/ic-delete.svg';
import ConfidentailIcon from '../../../assets/images/highalert.png';
import {
    EXISTING_ORDERS_LIST,
    LIS_ORDERS_RESULT,
    LOADER,
    Get_Anc_Result_Common_Data,
    Save_And_Update_Anc_Result_Common_Data,
    Get_Anc_Result_Data,
    Get_Anc_Result_Structured_Data,
    Save_Anc_Result_Data,
    Update_Anc_Result_Data,
    Delete_Anc_Result_Data,
} from '../../../utils/constant';

const { Option } = Select;

/**
 * AncTestProcedures
 *
 * ANC Card "Investigations" section: select investigation/procedure results ordered for
 * the patient and attach them to the ANC card. Mirrors the Discharge Summary Test &
 * Procedures feature, but keyed by anc_id instead of form_id.
 *
 * Props:
 *  - anc_id        (number) ANC card id (patient_obs_gyane_anc_cards.id) - REQUIRED to save
 *  - patient_id    (number) mhea/registration patient id
 *  - facility_id   (number)
 *  - enterprise_id (number)
 *  - encounter_id  (number) optional (defaults 0)
 *  - allowEdit     (bool)
 */
class AncTestProcedures extends Component {

    constructor(props) {
        super(props);
        Axios.defaults.headers.common['Authorization'] = LS_SERVICE.get('token');
        this.state = {
            allowEdit: props.allowEdit,
            dataLoading: true,
            resultModal: false,
            modalLoader: true,
            selectedResultData: {},
            ResultSectionsId: [],
            addResultList: [],
            ancResultList: [],
            ancResultCommonData: {},
            ancResultStructuredList: [],
            ExistingOrdersListed: [],
            ExistingOrdersListedOriginal: [],
            statusList: [],
            searchTestValue: '',
            searchTestStatus: '',
            service_delete_name: '',
            service_delete_date: '',
            deleteConfirmationModal: false,
        };
        this.searchTestResult = this.searchTestResult.bind(this);
        this.updateResultValue = debounce(this.updateResultValue, 1000);
        this.updateResultCommonValue = debounce(this.updateResultCommonValue, 1000);
    }

    async componentDidMount() {
        await this.getAncResultCommonData();
        await Promise.all([this.getAncResultData(), this.getAncResultStructuredData()]);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.allowEdit !== this.props.allowEdit) {
            this.setState({ allowEdit: this.props.allowEdit });
        }
        // When the ANC card id becomes available (after first save), (re)load its results.
        if (prevProps.anc_id !== this.props.anc_id && this.props.anc_id) {
            this.getAncResultCommonData();
            this.getAncResultData();
            this.getAncResultStructuredData();
        }
    }

    // Common where-condition used across all result endpoints.
    getWhereCondition = () => ({
        patient_id: parseInt(this.props.patient_id),
        encounter_id: parseInt(this.props.encounter_id || 0),
        facility_id: parseInt(this.props.facility_id),
        anc_id: parseInt(this.props.anc_id),
    });

    hasAncId = () => this.props.anc_id != null && parseInt(this.props.anc_id) > 0;

    /*********************** +RESULTS POPUP ***********************/

    handleModalPopup = async (e, modalName) => {
        if (e !== null) { e.preventDefault(); }

        if (modalName === 'resultModal' && !this.hasAncId()) {
            notification.error({
                message: 'Please save the ANC card once before adding investigations.',
                placement: 'topRight',
            });
            return;
        }

        await this.setState({ [modalName]: !this.state[modalName] });

        if (modalName === 'resultModal') {
            await this.setState({ searchTestValue: '', searchTestStatus: '' });
            await this.getCurrentInvOrdersList();
        }
        await this.setState({
            dataLoading: false,
            selectedResultData: {},
            ResultSectionsId: [],
            addResultList: [],
        });
        await this.getAncResultData();
        await this.getAncResultStructuredData();
    };

    handleResultModalCancel = async () => {
        await this.setState({ resultModal: false, selectedResultData: {}, searchTestValue: '', searchTestStatus: '' });
    };

    searchTestResult = async (e) => {
        const value = e.target.value;
        await this.setState({ searchTestValue: value });
        await this.filterTestValues(this.state.searchTestValue, this.state.searchTestStatus);
    };

    onSelectSearchStatus = async (value) => {
        await this.setState({ searchTestStatus: value, selectedResultData: {} });
        await this.filterTestValues(this.state.searchTestValue, this.state.searchTestStatus);
    };

    filterTestValues = async (searchTestValue, searchTestStatus) => {
        const tempArrList = this.state.ExistingOrdersListedOriginal || [];
        const filteredList = tempArrList.filter((result) => {
            const matchesName = !searchTestValue ||
                (result.service_name && result.service_name.toLowerCase().includes(searchTestValue.toLowerCase()));
            const matchesStatus = !searchTestStatus ||
                (result.status && result.status.toLowerCase().includes(searchTestStatus.toLowerCase()));
            return matchesName && matchesStatus;
        });
        await this.setState({ ExistingOrdersListed: filteredList });
    };

    // Fetch the patient's existing investigation/procedure orders for the popup list.
    getCurrentInvOrdersList = async () => {
        this.setState({ modalLoader: false, ExistingOrdersListed: [] });
        let PARAMS = {
            facilityId: parseInt(this.props.facility_id),
            patientId: parseInt(this.props.patient_id),
            service_type: 'both',
            timezoneOffsetMinutes: parseInt(LS_SERVICE.get('TIMEZONE_OFFSET_MINUTES')),
            encounterId: 0,
            status: 0,
        };
        try {
            const success = await Axios.post(EXISTING_ORDERS_LIST, PARAMS);
            if (success?.data?.status == true) {
                this.setState({ modalLoader: true });
                if (success.data.data && success.data.data.length > 0) {
                    let InvestigationOrdersListArr = success.data.data.filter((v, i) => v.serviceCategoryCode == "I" || v.serviceCategoryCode == "P" || v.serviceCategoryCode == "O");
                    if (InvestigationOrdersListArr.length > 0) {
                        const uniqueStatusData = [...new Map(InvestigationOrdersListArr?.map(item => [item.status, item])).values()];

                        console.log(uniqueStatusData);
                        await this.setState({ ExistingOrdersListed: InvestigationOrdersListArr, ExistingOrdersListedOriginal: InvestigationOrdersListArr, statusList : uniqueStatusData })
                    }
                    else {
                        await this.setState({ ExistingOrdersListed: [], ExistingOrdersListedOriginal: [], statusList: [] });
                    }
                }
            } else {
                this.setState({ modalLoader: true });
            }
        } catch (err) {
            this.setState({ modalLoader: true });
            console.log(err);
        }
    };

    // Existing orders list rendered on the left side of the popup.
    ExistingOrdersListLoad = () => {
        if (!this.state.ExistingOrdersListed || this.state.ExistingOrdersListed.length === 0) {
            return (<tr><td colSpan="5" align="center">No Orders</td></tr>);
        }
        // Current logged-in doctor; a report marked confidential stays hidden unless the
        // viewer is the admitting practitioner.
        const currentUserId = parseInt(LS_SERVICE.get('staff_id'));
        const admittingPractitionerId = parseInt(LS_SERVICE.get('ADMITTING_PRACTITIONER_ID'));

        return this.state.ExistingOrdersListed.map((data, i) => {
            const status = data?.investigationStatus?.toUpperCase().trim();
            const isReported = status === 'RD' || status === 'RP';
            const isConfidential = data.confidential_service == true
                || ('confidential_report_release_hold' in data && data.confidential_report_release_hold == true);
            // A confidential report is masked for everyone except the admitting practitioner.
            const maskedConfidential = isReported && isConfidential && (admittingPractitionerId != currentUserId);
            // Result is viewable when finalized/reported AND not withheld as confidential.
            const canViewResult = (
                status === 'FINALIZED' || status === 'REPORTED' || status === 'CORRECTED' ||
                status === 'COMPLETED' || status === 'RD' || status === 'RP'
            ) && (
                (data?.confidential_service == false)
                || (data.confidential_service == true && 'confidential_report_release_hold' in data && data.confidential_report_release_hold == false)
            );

            return (
                <tr key={i}>
                    <td>{data.enteredDate ? moment(data.enteredDate).format('DD MMM, YYYY | hh:mm A') : '-'}</td>
                    <td>{data.ordered_Location}</td>
                    <td>{data.ordered_by}</td>
                    <td className={maskedConfidential ? 'text-danger' : ''}>
                        {maskedConfidential ? (
                            <Tooltip zIndex={100000} placement="topLeft" arrowPointAtCenter={true} title="Service Mark As Confidential">
                                <span> {data.service_name}{data?.unit ? (' (' + data.unit + ')') : null}
                                    {data?.confidential_service === true
                                        ? <img src={ConfidentailIcon} className="ml-3" alt="confidential" style={{ width: '15px', height: 'auto' }} />
                                        : null}
                                </span>
                            </Tooltip>
                        ) : (
                            <span> {data.service_name}{data?.unit ? (' (' + data.unit + ')') : null}
                                {(data?.confidential_service === true || ('confidential_report_release_hold' in data && data.confidential_report_release_hold == true)) ? (
                                    <Tooltip zIndex={100000} placement="right" title="Please connect with the lab for this report">
                                        <img src={ConfidentailIcon} className="ml-3" alt="confidential" style={{ width: '15px', height: 'auto' }} />
                                    </Tooltip>
                                ) : null}
                            </span>
                        )}
                    </td>
                    {canViewResult
                        ? <td className="cursor-p text-success" onClick={() => this.handleTestDetails(data)}>{data.isProfile === true ? 'View Profile' : data.status}</td>
                        : <td>{data.status}</td>}
                </tr>
            );
        });
    };

    // Fetch the detailed result of the selected test/procedure.
    handleTestDetails = async (data) => {
        const Parameter = {
            enterprise_id: this.props.enterprise_id,
            facility_id: this.props.facility_id,
            registration_id: 0,
            registration_no: '',
            encounter_id: 0,
            encounter_no: '',
            serviceorder_id: data.orderId,
            serviceorderdtl_id: data.id,
            service_id: data.serviceId,
            service_name: '',
            fromDate: null,
            toDate: null,
            userId: LS_SERVICE.get('staff_id'),
            pageSize: 300,
        };
        try {
            const response = await Axios.post(LIS_ORDERS_RESULT, Parameter);
            if (response?.data?.status == true && response?.data?.data?.length > 0) {
                await this.setState({ selectedResultData: response.data.data[0] });
            } else {
                await this.setState({ selectedResultData: {} });
            }
        } catch (err) {
            await this.setState({ selectedResultData: {} });
        }
    };

    onResultFinishFailed = () => {
        if (!this.state.ResultSectionsId.length) {
            notification.error({ message: 'Please select result fields.', placement: 'topRight' });
        }
    };

    checkResultHeadingCheckbox = (type, profileItem) => {
        const { selectedResultData, ResultSectionsId } = this.state;
        if (type == 'profile') {
            if (!profileItem || !profileItem.ordDtlPara || profileItem.ordDtlPara.length === 0) return false;
            const allIds = profileItem.ordDtlPara.map(para => para.order_component_id + '_' + para.sequenceNo);
            return allIds.every(id => ResultSectionsId.includes(id));
        } else {
            if (!selectedResultData.ordDtl) return false;
            const allIds = selectedResultData.ordDtl.map(e => e.order_component_id.toString());
            return allIds.every(id => ResultSectionsId.includes(id));
        }
    };

    buildServiceOrderData = (componentData, event) => ({
        patient_id: parseInt(this.props.patient_id),
        facility_id: parseInt(this.props.facility_id),
        encounter_id: parseInt(this.props.encounter_id || 0),
        anc_id: parseInt(this.props.anc_id),
        order_component_id: componentData.order_component_id.toString(),
        service_name: event.service_name,
        service_id: event.service_id,
        service_date: event.service_date,
        ref_range: (componentData.reference_range || '').replaceAll('<br/>', '<br>').split('<br>').join('\r\n'),
        component_name: componentData.component_name,
        test_value: componentData.test_value,
        uom_code: componentData.uomCode,
    });

    checkResultAllChild = (event, profileItem) => {
        const { selectedResultData, ResultSectionsId } = this.state;
        if (event.target.type == 'profile') {
            const ordDtlItems = profileItem ? [profileItem] : selectedResultData.ordDtl;
            ordDtlItems.forEach((indexData) => {
                indexData.ordDtlPara.forEach((para) => {
                    let order_component_id = para.order_component_id + '_' + para.sequenceNo;
                    const tcIndex = ResultSectionsId.indexOf(order_component_id);
                    if (event.target.checked) {
                        if (tcIndex === -1) {
                            let service_order_data = this.buildServiceOrderData(
                                { ...para, order_component_id },
                                event.target
                            );
                            this.makeResultSaveData(service_order_data, tcIndex, 'add');
                            ResultSectionsId.push(order_component_id.toString());
                        }
                    } else if (tcIndex !== -1) {
                        this.makeResultSaveData([], tcIndex, 'minus');
                        ResultSectionsId.splice(tcIndex, 1);
                    }
                });
            });
        } else {
            selectedResultData.ordDtl.forEach((indexData) => {
                let order_component_id = indexData.order_component_id.toString();
                const tcIndex = ResultSectionsId.indexOf(order_component_id);
                if (event.target.checked) {
                    if (tcIndex === -1) {
                        let service_order_data = this.buildServiceOrderData(indexData, event.target);
                        this.makeResultSaveData(service_order_data, tcIndex, 'add');
                        ResultSectionsId.push(order_component_id.toString());
                    }
                } else if (tcIndex !== -1) {
                    this.makeResultSaveData([], tcIndex, 'minus');
                    ResultSectionsId.splice(tcIndex, 1);
                }
            });
        }
        this.setState({ ResultSectionsId });
    };

    insertResultHtml = async (event) => {
        const { ResultSectionsId } = this.state;
        let service_order_data = {
            patient_id: parseInt(this.props.patient_id),
            facility_id: parseInt(this.props.facility_id),
            encounter_id: parseInt(this.props.encounter_id || 0),
            anc_id: parseInt(this.props.anc_id),
            order_component_id: event.target.id.toString(),
            service_id: event.target.service_id,
            service_name: event.target.service_name,
            service_date: event.target.service_date,
            ref_range: event.target.ref_range,
            component_name: event.target.component_name,
            test_value: event.target.test_value,
            uom_code: event.target.uom_code,
        };
        if (event.target.checked) {
            let tcIndex = ResultSectionsId.indexOf(event.target.id.toString());
            if (tcIndex == -1) { ResultSectionsId.push(event.target.id.toString()); }
            this.makeResultSaveData(service_order_data, tcIndex, 'add');
            this.setState({ ResultSectionsId });
        } else {
            let tcIndex = ResultSectionsId.indexOf(event.target.id.toString());
            if (tcIndex != -1) { ResultSectionsId.splice(tcIndex, 1); }
            this.makeResultSaveData(service_order_data, tcIndex, 'minus');
            this.setState({ ResultSectionsId });
        }
    };

    makeResultSaveData = (service_order_data, index, action_type) => {
        if (action_type == 'add') {
            this.setState(prevState => ({ addResultList: [...prevState.addResultList, service_order_data] }));
        } else {
            this.setState(prevState => ({ addResultList: prevState.addResultList.filter((_, i) => i !== index) }));
        }
    };

    existingResultsSave = async (e) => {
        // Prevent any native form submission from bubbling to the parent ANC <Form>
        // (this component is rendered inside anccard's form), which would reload the page.
        if (e && typeof e.preventDefault === 'function') { e.preventDefault(); }
        if (e && typeof e.stopPropagation === 'function') { e.stopPropagation(); }

        let Params = {
            where_condition: this.getWhereCondition(),
            result_data: this.state.addResultList,
            user_id: LS_SERVICE.get('staff_id'),
            user_name: LS_SERVICE.get('profile')?.data?.full_name || ('Dr. ' + LS_SERVICE.get('staff_name')),
        };
        try {
            await Axios.post(Save_Anc_Result_Data, Params);
            await this.getAncResultData();
            await this.getAncResultStructuredData();
            await this.setState({ resultModal: false });
            notification.success({ message: 'Test And Procedures Updated Successfully', placement: 'topRight' });
        } catch (error) {
            notification.error({ message: 'Something went wrong! Unable to save the data', placement: 'topRight' });
        }
    };

    /*********************** LISTED TESTS & PROCEDURES ***********************/

    onHandleModalPopup = async (service_delete_name, service_delete_date = null) => {
        await this.setState({ deleteConfirmationModal: true, service_delete_name, service_delete_date });
    };

    handleCloseModal = () => {
        this.setState({ service_delete_name: '', service_delete_date: '', deleteConfirmationModal: false });
    };

    deleteAncResult = async () => {
        let BODY = {
            patient_id: parseInt(this.props.patient_id),
            facility_id: parseInt(this.props.facility_id),
            anc_id: parseInt(this.props.anc_id),
            service_delete_name: this.state.service_delete_name,
            service_delete_date: this.state.service_delete_date,
            user_id: LS_SERVICE.get('staff_id'),
            user_name: LS_SERVICE.get('profile')?.data?.full_name || ('Dr. ' + LS_SERVICE.get('staff_name')),
        };
        try {
            await Axios.post(Delete_Anc_Result_Data, BODY);
        } catch (err) { console.log(err); }
        await this.getAncResultData();
        await this.getAncResultStructuredData();
        await this.setState({ service_delete_name: '', service_delete_date: '', deleteConfirmationModal: false });
    };

    getAncResultCommonData = async () => {
        if (!this.hasAncId()) return;
        try {
            const res = await Axios.post(Get_Anc_Result_Common_Data, qs.stringify(this.getWhereCondition()));
            if (res.data) {
                await this.setState({ ancResultCommonData: res?.data?.data || {} });
            }
        } catch (err) { console.log(err); }
    };

    getAncResultData = async () => {
        if (!this.hasAncId()) return;
        try {
            const res = await Axios.post(Get_Anc_Result_Data, qs.stringify(this.getWhereCondition()));
            if (res.data) {
                let data = res.data.data || [];
                await this.setState({ ancResultList: data });
                if (data.length > 0) {
                    await this.makeSavedResultData(data);
                } else {
                    await this.setState({ ResultSectionsId: [], addResultList: [] });
                }
            }
        } catch (err) { console.log(err); }
    };

    getAncResultStructuredData = async () => {
        if (!this.hasAncId()) return;
        try {
            const res = await Axios.post(Get_Anc_Result_Structured_Data, qs.stringify(this.getWhereCondition()));
            if (res.data) {
                await this.setState({ ancResultStructuredList: res.data.data || [] });
            }
        } catch (err) { console.log(err); }
    };

    makeSavedResultData = (result_data) => {
        const newResultSectionsId = [...this.state.ResultSectionsId];
        const newAddResultList = [...this.state.addResultList];
        result_data.forEach((row) => {
            if (!newResultSectionsId.includes(row.order_component_id.toString())) {
                newResultSectionsId.push(row.order_component_id.toString());
                newAddResultList.push({
                    patient_id: parseInt(row.patient_id),
                    facility_id: parseInt(row.facility_id),
                    encounter_id: parseInt(row.encounter_id),
                    anc_id: parseInt(row.anc_id),
                    order_component_id: row.order_component_id.toString(),
                    service_id: row.service_id,
                    service_name: row.service_name,
                    service_date: moment(row.service_date).format('DD MMM, YYYY'),
                    ref_range: row.ref_range,
                    component_name: row.component_name,
                    test_value: row.test_value,
                    uom_code: row.uom_code,
                    remarks: row.remarks,
                });
            }
        });
        this.setState({ ResultSectionsId: newResultSectionsId, addResultList: newAddResultList });
    };

    handleTestProcedureChange = (e, key, value, component) => {
        if (key === 'test_value') { component[key] = value; return; }
        const list = this.state.ancResultStructuredList || [];
        for (const group of list) {
            for (const date of group?.dates || []) {
                for (const obj of date?.component_data || []) {
                    if (obj.id === component.id) { obj[key] = value; break; }
                }
            }
        }
        clearTimeout(this.editTimer);
        this.editTimer = setTimeout(() => {
            this.setState({ ancResultStructuredList: [...this.state.ancResultStructuredList] });
        }, 500);
    };

    handleTestProcedureBlur = async (e, key, value, component) => {
        const list = this.state.ancResultStructuredList || [];
        for (const group of list) {
            for (const date of group?.dates || []) {
                for (const obj of date?.component_data || []) {
                    if (obj.id === component.id) { obj[key] = value; break; }
                }
            }
        }
        this.setState({ ancResultStructuredList: list });
        await this.updateResultValue(key, value, component);
    };

    updateResultValue = async (key, value, component) => {
        try {
            await Axios.post(Update_Anc_Result_Data, { id: component.id, key, value });
            await this.getAncResultData();
            await this.getAncResultStructuredData();
        } catch (err) { console.log(err); }
    };

    handleTestProcedureCommonDataChange = async (e, key, value) => {
        var ancResultCommonData = this.state.ancResultCommonData || {};
        if (key == 'print_type') {
            var actualPrintValue = value == true ? 'table' : 'oneliner';
            ancResultCommonData[key] = actualPrintValue;
            this.setState({ ancResultCommonData });
            this.updateResultCommonValue(key, actualPrintValue);
        } else {
            ancResultCommonData[key] = value;
            this.setState({ ancResultCommonData });
        }
    };

    handleTestProcedureCommonDataBlurChange = async (e, key, value) => {
        this.updateResultCommonValue(key, value);
    };

    updateResultCommonValue = async (key, value) => {
        if (!this.hasAncId()) return;
        try {
            await Axios.post(Save_And_Update_Anc_Result_Common_Data, {
                ...this.getWhereCondition(),
                key,
                value,
            });
            await this.getAncResultCommonData();
        } catch (err) { console.log(err); }
    };

    isHtmlValue = (value) => typeof value === 'string' && /<\/?[a-z][\s\S]*>/i.test(value);

    renderTestValue = (data) => {
        const testValue = data?.test_value ?? '';
        const isTextResult = data?.result_value_type?.toLowerCase() === 'text';
        const isAbnormalResult = data?.isAbnormal === 'P' || data?.isAbnormal === 'C';
        if (!isTextResult) {
            return testValue ? (<a href={testValue} target="_blank" rel="noreferrer">{testValue}</a>) : null;
        }
        if (this.isHtmlValue(testValue)) {
            return (
                <div
                    style={isAbnormalResult ? { textDecoration: 'underline' } : undefined}
                    dangerouslySetInnerHTML={{ __html: testValue.replace(/\n/g, '<br />') }}
                />
            );
        }
        return isAbnormalResult ? <u>{testValue}</u> : testValue;
    };

    chunkArray = (arr, size = 5) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += size) { chunks.push(arr.slice(i, i + size)); }
        return chunks;
    };

    autoHeight = (e) => { e.target.style.height = e.target.scrollHeight + 'px'; };

    /*********************** TITLE / DESCRIPTION ROWS (with +/-) ***********************/
    // These rows are owned by the parent (anccard) and saved with the ANC card form as
    // test_procedures_data. They accept bold text (contentEditable + Ctrl/Cmd+B) and store
    // HTML markup as a string in title/description.

    getTestProcedureRows = () => {
        const rows = this.props.testProcedureRows;
        return Array.isArray(rows) && rows.length > 0 ? rows : [{ title: '', description: '' }];
    };

    emitTestProcedureRows = (rows) => {
        if (typeof this.props.onTestProcedureRowsChange === 'function') {
            this.props.onTestProcedureRowsChange(rows);
        }
    };

    handleTestProcedureRowChange = (index, field, value) => {
        const rows = [...this.getTestProcedureRows()];
        if (!rows[index]) return;
        rows[index] = { ...rows[index], [field]: value };
        this.emitTestProcedureRows(rows);
    };

    addTestProcedureRow = () => {
        this.emitTestProcedureRows([...this.getTestProcedureRows(), { title: '', description: '' }]);
    };

    removeTestProcedureRow = (index) => {
        const rows = this.getTestProcedureRows().filter((_, i) => i !== index);
        this.emitTestProcedureRows(rows.length > 0 ? rows : [{ title: '', description: '' }]);
    };

    // True when the rich-text HTML has visible text once tags/entities are stripped.
    hasRichTextContent = (html) => {
        if (!html) return false;
        const text = String(html).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
        return text !== '';
    };

    // Sync a contentEditable field from state only when not focused (avoids caret reset).
    setRichTextRef = (index, field, node) => {
        if (!this.richTextRefs) this.richTextRefs = {};
        const key = index + '_' + field;
        if (node) {
            this.richTextRefs[key] = node;
            const value = this.getTestProcedureRows()?.[index]?.[field] || '';
            if (node.innerHTML !== value && document.activeElement !== node) {
                node.innerHTML = value;
            }
        } else {
            delete this.richTextRefs[key];
        }
    };

    renderRichTextField = (index, field, value, placeholder) => {
        const isEmpty = !this.hasRichTextContent(value);
        const allowEdit = this.state.allowEdit;
        return (
            <div className="anc-richtext-wrap" style={{ position: 'relative' }}>
                <div
                    ref={(node) => this.setRichTextRef(index, field, node)}
                    className="form-control anc-richtext"
                    contentEditable={allowEdit}
                    suppressContentEditableWarning={true}
                    style={{ minHeight: '38px', overflowY: 'auto', whiteSpace: 'pre-wrap' }}
                    onInput={(e) => this.handleTestProcedureRowChange(index, field, e.currentTarget.innerHTML)}
                    onBlur={(e) => this.handleTestProcedureRowChange(index, field, e.currentTarget.innerHTML)}
                />
                {isEmpty ? (
                    <span
                        className="anc-richtext-placeholder"
                        style={{ position: 'absolute', top: '8px', left: '12px', color: '#bfbfbf', pointerEvents: 'none' }}
                    >
                        {placeholder}
                    </span>
                ) : null}
            </div>
        );
    };

    TestProcedureRowsLoad = () => {
        const rows = this.getTestProcedureRows();
        const allowEdit = this.state.allowEdit;
        return rows.map((row, index) => (
            <div className="row mt-2 align-items-center" key={index}>
                <div className="col-5">
                    <div className="form-group antInputItem hasdata mb-0">
                        {this.renderRichTextField(index, 'title', row.title, 'Title')}
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group antInputItem hasdata mb-0">
                        {this.renderRichTextField(index, 'description', row.description, 'Description')}
                    </div>
                </div>
                <div className="col-1 text-center">
                    {allowEdit
                        ? (index === rows.length - 1
                            ? <a href="javascript:void(0)" className="btn btn-outline-primary small px-2" onClick={this.addTestProcedureRow}>+</a>
                            : <a href="javascript:void(0)" className="btn btn-outline-danger small px-2" onClick={() => this.removeTestProcedureRow(index)}>-</a>)
                        : null}
                </div>
            </div>
        ));
    };

    // Listing the saved results on screen, grouped by service & date.
    ResultListLoad = () => {
        const { ancResultStructuredList, allowEdit } = this.state;
        if (!ancResultStructuredList?.length) return null;

        return (
            <>
                {ancResultStructuredList.map((service) => {
                    const allComponents = [
                        ...new Map(
                            service.dates
                                .flatMap(date => date.component_data)
                                .map(comp => [comp.component_name, comp])
                        ).values()
                    ];
                    const dateChunks = this.chunkArray(service.dates, 5);

                    return (
                        <div key={service.service_id}>
                            <p className="mt-2">
                                <b>{service.service_name}</b>
                                {allowEdit && (
                                    <span className="cursor-p ml-2" onClick={() => this.onHandleModalPopup(service.service_name)}>
                                        <img src={DeleteIcon} alt="delete" style={{ width: '18px', height: 'auto' }} />
                                    </span>
                                )}
                            </p>
                            {dateChunks.map((dateGroup, chunkIndex) => (
                                <table className="table table-bordered my-2" key={chunkIndex}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '20%' }}><strong>TEST NAME</strong></th>
                                            {dateGroup.map(date => (
                                                <th style={{ width: '12%' }} key={date.service_date}>
                                                    <strong>{moment(date.service_date).format('DD MMM, YYYY')}</strong>
                                                    {allowEdit && (
                                                        <span className="cursor-p ml-2" onClick={() => this.onHandleModalPopup(service.service_name, date.service_date)}>
                                                            <img src={DeleteIcon} alt="delete" style={{ width: '16px', height: 'auto', filter: 'brightness(0) invert(1)' }} />
                                                        </span>
                                                    )}
                                                </th>
                                            ))}
                                            <th style={{ width: '20%' }}><strong>REFERENCE INTERVAL</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allComponents.map(component => (
                                            <tr key={component.component_name}>
                                                <td><strong>{component.component_name}</strong></td>
                                                {dateGroup.map(date => {
                                                    const dateComponent = date.component_data.find(x => x.component_name === component.component_name);
                                                    return (
                                                        <td key={`${date.service_date}_${component.component_name}`}>
                                                            {dateComponent ? (
                                                                <>
                                                                    <div
                                                                        contentEditable={allowEdit}
                                                                        suppressContentEditableWarning
                                                                        dangerouslySetInnerHTML={{ __html: dateComponent.test_value || '' }}
                                                                        onInput={(e) => this.handleTestProcedureChange(e, 'test_value', e.currentTarget.innerHTML, dateComponent)}
                                                                        onBlur={(e) => this.handleTestProcedureBlur(e, 'test_value', e.currentTarget.innerHTML, dateComponent)}
                                                                    />
                                                                    <div
                                                                        contentEditable={allowEdit}
                                                                        suppressContentEditableWarning
                                                                        dangerouslySetInnerHTML={{ __html: dateComponent.uom_code || '' }}
                                                                        onInput={(e) => this.handleTestProcedureChange(e, 'uom_code', e.currentTarget.innerHTML, dateComponent)}
                                                                        onBlur={(e) => this.handleTestProcedureBlur(e, 'uom_code', e.currentTarget.innerHTML, dateComponent)}
                                                                    />
                                                                </>
                                                            ) : ('-')}
                                                        </td>
                                                    );
                                                })}
                                                <td>{component.ref_range}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ))}
                        </div>
                    );
                })}
            </>
        );
    };

    render() {
        const { selectedResultData, ResultSectionsId, allowEdit } = this.state;

        return (
            <>
                <div className="row mt-4 align-items-center">
                    <div className="col-6">
                        <span className="title">INVESTIGATIONS</span>
                    </div>
                    <div className="col-6 text-right d-flex align-items-center justify-content-end">
                        {allowEdit ? (
                            <div className="custom-control custom-checkbox custom-control-inline mr-3">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="anc_print_in_table"
                                    checked={this.state.ancResultCommonData?.print_type == 'table'}
                                    onChange={(e) => this.handleTestProcedureCommonDataChange(e, 'print_type', e.target.checked)}
                                />
                                <label className="custom-control-label" htmlFor="anc_print_in_table">Print in table format</label>
                            </div>
                        ) : null}
                        {allowEdit ? (
                            <button
                                type="button"
                                className="btn btn-outline-primary small px-2 text-uppercase"
                                onClick={(e) => this.handleModalPopup(e, 'resultModal')}
                            >
                                + Results
                            </button>
                        ) : null}
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-12">
                        {this.ResultListLoad()}
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-12">
                        <div className="form-group antInputItem hasdata mb-0">
                            <Input.TextArea
                                className="form-control diagnosis_notes_class"
                                id="anc_investigation_remarks"
                                name="anc_investigation_remarks"
                                autoSize={{ minRows: 2, maxRows: 6 }}
                                maxLength={2000}
                                disabled={!allowEdit}
                                value={this.state.ancResultCommonData?.remarks || ''}
                                onChange={(e) => this.handleTestProcedureCommonDataChange(e, 'remarks', e.target.value)}
                                onBlur={(e) => this.handleTestProcedureCommonDataBlurChange(e, 'remarks', e.target.value)}
                            />
                            <label htmlFor="anc_investigation_remarks">Remarks</label>
                        </div>
                    </div>
                </div>

                {/* Title / Description rows with +/- (accept bold text) */}
                {this.TestProcedureRowsLoad()}

                {/* Delete Confirmation Modal */}
                <Modal
                    title="Delete Confirmation"
                    centered
                    visible={this.state.deleteConfirmationModal}
                    onCancel={this.handleCloseModal}
                    zIndex={99999}
                    footer={false}
                    destroyOnClose={true}
                    maskClosable={false}
                    width={600}
                    closable={true}
                >
                    <div className="modal-content border-0">
                        <div className="modal-body">
                            <div className="row mt-2">
                                <div className="col-12">
                                    <h6>Are you sure you want to delete this investigation from the ANC card?</h6>
                                </div>
                            </div>
                            <div className="row mt-4 mb-2 float-right">
                                <button onClick={this.handleCloseModal} type="button" className="btn btn-outline-secondary mr-3">NO</button>
                                <button onClick={this.deleteAncResult} type="button" className="btn btn-primary mr-3">YES</button>
                            </div>
                        </div>
                    </div>
                </Modal>

                {/* Result selection Modal */}
                <Modal
                    title="Result"
                    centered
                    visible={this.state.resultModal}
                    onCancel={this.handleResultModalCancel}
                    zIndex={99999}
                    footer={false}
                    destroyOnClose={true}
                    maskClosable={false}
                    width={1200}
                    className="xlarge-modal-custom"
                >
                    <Form
                        layout="vertical"
                        name="existingResults"
                        className="emrfrm"
                        onFinish={this.existingResultsSave}
                        onFinishFailed={this.onResultFinishFailed}
                        autoComplete="off"
                    >
                        <div className="row mt-4">
                            <div className="col-6">
                                <div className="row">
                                    <div className={this.state.searchTestValue ? 'col-8 antInputItem hasdata position-relative' : 'col-8 antInputItem position-relative'}>
                                        <Form.Item name="searchtest" label="Search Test/Procedure" id="searchtest">
                                            <Input
                                                onChange={this.searchTestResult}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                                                maxLength={100}
                                                name="searchTestValue"
                                                value={this.state.searchTestValue}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="col-4 antInputItem hasdata position-relative">
                                        <Form.Item label="Status" name="searchTestStatus" className="margin-prev">
                                            <Select
                                                showSearch
                                                value={this.state.searchTestStatus}
                                                optionFilterProp="children"
                                                filterOption={(input, option) => option.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0}
                                                onChange={(val) => this.onSelectSearchStatus(val)}
                                                // Render the dropdown inside the modal so it isn't hidden behind it.
                                                getPopupContainer={(trigger) => trigger.parentNode}
                                                dropdownStyle={{ zIndex: 100000 }}
                                            >
                                                <Option value="">Select Status</Option>
                                                {this.state.statusList && this.state.statusList.length > 0
                                                    ? this.state.statusList.map((d, i) => (<Option key={i} value={d.status} label={d.status}>{d.status}</Option>))
                                                    : null}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            {Object.entries(selectedResultData).length > 0 ? (
                                <div className="col-6">
                                    <div className="row pt-1">
                                        <div className="col-6 font-weight-bold">{selectedResultData.component_name}</div>
                                        <div className="col-2 font-weight-bold">{selectedResultData.test_status}</div>
                                        <div className="col-4 text-right">
                                            <span>Order Date : </span>
                                            <span className="font-weight-bold">{selectedResultData.serviceorder_date ? moment(selectedResultData.serviceorder_date).format('DD MMM, YYYY | hh:mm A') : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        <div className="row mt-4">
                            <div className="col-6">
                                <div className="row">
                                    <div className="col-12" style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
                                        <table className="table table-bordered rounded-0 position-sticky">
                                            <thead>
                                                <tr>
                                                    <th>ORDER DATE &amp; TIME</th>
                                                    <th>ORDERING LOCATION</th>
                                                    <th>ORDERED BY</th>
                                                    <th>ORDER NAME</th>
                                                    <th>STATUS</th>
                                                </tr>
                                            </thead>
                                            <tbody>{this.ExistingOrdersListLoad()}</tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {selectedResultData && Object.entries(selectedResultData).length > 0 && selectedResultData.result_value_type ? (
                                <div className="col-6">
                                    {selectedResultData.isProfile == true && Array.isArray(selectedResultData.ordDtl) ? (
                                        /* PROFILE result: each ordDtl group has its own ordDtlPara rows. */
                                        selectedResultData.ordDtl.map((b, bIndex) => (
                                            <React.Fragment key={'profile' + bIndex}>
                                                <hr style={{ margin: '10px 0', borderColor: '#ccc' }} />
                                                <div className="card cardbg rounded-0 mb-0">
                                                    <div className="row d-flex ml-1">
                                                        <div className="col-6">
                                                            <span className="font-weight-bold">{b.component_name} </span>
                                                        </div>
                                                        <div className="col-6">
                                                            <label className="text-muted banner-row-sm">Status:</label>
                                                            <label className="font-weight-medium ">
                                                                {b.testStatus ? <span className={(b.testStatusCode === 'RD' || b.testStatusCode === 'RP') ? 'text-danger' : 'text-dark'}>{b.testStatus}</span> : ''}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table className="table table-bordered mt-0">
                                                    <thead>
                                                        {(selectedResultData.test_type !== null && selectedResultData.result_value_type.toUpperCase() == 'TEXT') ? (
                                                            <tr>
                                                                {(typeof b.ordDtlPara !== 'undefined' && b.ordDtlPara.length > 0) ? (
                                                                    <th width="30%">
                                                                        <div className="custom-control custom-checkbox">
                                                                            <input
                                                                                onChange={(e) => this.checkResultAllChild({
                                                                                    target: {
                                                                                        id: b.component_name,
                                                                                        type: 'profile',
                                                                                        service_id: selectedResultData.serviceorder_id,
                                                                                        service_name: b.component_name,
                                                                                        service_date: moment(selectedResultData.serviceorder_date).format('DD MMM, YYYY'),
                                                                                        checked: e.target.checked,
                                                                                    },
                                                                                }, b)}
                                                                                type="checkbox"
                                                                                checked={this.checkResultHeadingCheckbox('profile', b) || false}
                                                                                className="custom-control-input"
                                                                                id={'customCheck' + b.component_name}
                                                                            />
                                                                            <label style={{ color: 'white' }} className="custom-control-label" htmlFor={'customCheck' + b.component_name}>TEST NAME</label>
                                                                        </div>
                                                                    </th>
                                                                ) : (
                                                                    <th width="30%">TEST NAME</th>
                                                                )}
                                                                <th width="20%">RESULT</th>
                                                                <th width="20%">UNIT</th>
                                                                <th width="30%">REFERENCE INTERVAL</th>
                                                            </tr>
                                                        ) : null}
                                                    </thead>
                                                    <tbody>
                                                        {selectedResultData.result_value_type.toUpperCase() === 'TEXT'
                                                            ? (selectedResultData.test_type === 'GRP'
                                                                ? ((typeof b.ordDtlPara !== 'undefined' && b.ordDtlPara.length > 0)
                                                                    ? b.ordDtlPara.map((c, cIndex) => (
                                                                        <tr key={'para' + bIndex + '_' + cIndex}>
                                                                            <td>
                                                                                <div className="custom-control custom-checkbox">
                                                                                    <input
                                                                                        onChange={(e) => this.insertResultHtml({
                                                                                            target: {
                                                                                                id: c.order_component_id + '_' + c.sequenceNo,
                                                                                                service_id: selectedResultData.serviceorder_id,
                                                                                                service_name: b.component_name,
                                                                                                service_date: moment(selectedResultData.serviceorder_date).format('DD MMM, YYYY'),
                                                                                                ref_range: (c.reference_range || '').replaceAll('<br/>', '<br>').split('<br>').join('\r\n'),
                                                                                                component_name: c.component_name,
                                                                                                test_value: c.test_value,
                                                                                                uom_code: c.uomCode,
                                                                                                checked: e.target.checked,
                                                                                            },
                                                                                        })}
                                                                                        type="checkbox"
                                                                                        checked={(ResultSectionsId && ResultSectionsId.indexOf(c.order_component_id + '_' + c.sequenceNo) != -1) ? true : false}
                                                                                        className="custom-control-input"
                                                                                        id={'customCheckPara' + bIndex + '_' + cIndex}
                                                                                    />
                                                                                    <label className="custom-control-label" htmlFor={'customCheckPara' + bIndex + '_' + cIndex}>{c.component_name || null}</label>
                                                                                </div>
                                                                            </td>
                                                                            {c.confidential_report_release_hold ? (
                                                                                <td>Confidential</td>
                                                                            ) : (
                                                                                <td align="center" className={(c.isAbnormal === 'P' || c.isAbnormal === 'C') ? 'text-danger' : c.isAbnormal === 'N' ? 'text-success' : 'text-warning font-weight-medium'}>
                                                                                    {this.renderTestValue(c)}
                                                                                </td>
                                                                            )}
                                                                            <td>{c.uomCode}</td>
                                                                            <td style={{ whiteSpace: 'pre' }}>{(c.reference_range || '').replaceAll('<br/>', '<br>').split('<br>').join('\r\n')}</td>
                                                                        </tr>
                                                                    ))
                                                                    : null)
                                                                : null)
                                                            : (<tr><td colSpan="4"><object width="100%" height="500" data={selectedResultData.result_link} type="application/pdf"> </object></td></tr>)}
                                                    </tbody>
                                                </table>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                    <div className="row">
                                        <div className="col-12">
                                            <table className="table table-bordered">
                                                <thead>
                                                    {(selectedResultData.test_type !== null && selectedResultData.result_value_type.toUpperCase() == 'TEXT' && selectedResultData.departmentType != 'RIS') ? (
                                                        <tr>
                                                            <th width="30%">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        onChange={(e) => this.checkResultAllChild({
                                                                            target: {
                                                                                id: selectedResultData.component_name,
                                                                                type: 'normal',
                                                                                service_id: selectedResultData.serviceorder_id,
                                                                                service_name: selectedResultData.component_name,
                                                                                service_date: moment(selectedResultData.serviceorder_date).format('DD MMM, YYYY'),
                                                                                checked: e.target.checked,
                                                                            },
                                                                        })}
                                                                        type="checkbox"
                                                                        checked={this.checkResultHeadingCheckbox('normal') || false}
                                                                        className="custom-control-input"
                                                                        id={'customCheck' + selectedResultData.component_name}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={'customCheck' + selectedResultData.component_name}>TEST NAME</label>
                                                                </div>
                                                            </th>
                                                            <th width="20%">RESULT</th>
                                                            <th width="20%">UNIT</th>
                                                            <th width="30%">REFERENCE INTERVAL</th>
                                                        </tr>
                                                    ) : null}
                                                </thead>
                                                <tbody>
                                                    {selectedResultData.departmentType === 'RIS' ? (
                                                        <tr><td><object width="100%" height="500" data={selectedResultData.result_link} type="application/pdf"> </object></td></tr>
                                                    ) : (selectedResultData.result_value_type.toUpperCase() == 'TEXT' ? (
                                                        selectedResultData.test_type === 'GRP' && selectedResultData.ordDtl ? (
                                                            selectedResultData.ordDtl.map((b, index) => (
                                                                <tr key={'result' + index}>
                                                                    <td>
                                                                        <div className="custom-control custom-checkbox">
                                                                            <input
                                                                                onChange={(e) => this.insertResultHtml({
                                                                                    target: {
                                                                                        id: b.order_component_id,
                                                                                        service_id: selectedResultData.serviceorder_id,
                                                                                        service_name: selectedResultData.component_name,
                                                                                        service_date: moment(selectedResultData.serviceorder_date).format('DD MMM, YYYY'),
                                                                                        ref_range: (b.reference_range || '').replaceAll('<br/>', '<br>').split('<br>').join('\r\n'),
                                                                                        component_name: b.component_name,
                                                                                        test_value: b.test_value,
                                                                                        uom_code: b.uomCode,
                                                                                        checked: e.target.checked,
                                                                                    },
                                                                                })}
                                                                                type="checkbox"
                                                                                checked={(ResultSectionsId && ResultSectionsId.indexOf(b.order_component_id.toString()) != -1) ? true : false}
                                                                                className="custom-control-input"
                                                                                id={'customCheck' + index}
                                                                            />
                                                                            <label className="custom-control-label" htmlFor={'customCheck' + index}>{b.component_name || null}</label>
                                                                        </div>
                                                                    </td>
                                                                    <td align="right" className={b.isAbnormal === 'P' ? 'text-danger' : b.isAbnormal === 'N' ? 'text-success' : 'text-dark font-weight-medium'}>{this.renderTestValue(b)}</td>
                                                                    <td>{b.uomCode}</td>
                                                                    <td style={{ whiteSpace: 'pre' }}>{(b.reference_range || '').replaceAll('<br/>', '<br>').split('<br>').join('\r\n')}</td>
                                                                </tr>
                                                            ))
                                                        ) : (selectedResultData.test_type !== null ? (
                                                            <tr key={'result' + selectedResultData.serviceorder_id}>
                                                                <td>
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input
                                                                            onChange={(e) => this.insertResultHtml({
                                                                                target: {
                                                                                    id: selectedResultData.serviceorder_id,
                                                                                    service_id: selectedResultData.serviceorder_id,
                                                                                    service_name: selectedResultData.component_name,
                                                                                    service_date: moment(selectedResultData.serviceorder_date).format('DD MMM, YYYY'),
                                                                                    ref_range: (selectedResultData.reference_range || '').replaceAll('<br/>', '<br>').split('<br>').join('\r\n'),
                                                                                    test_value: selectedResultData.test_value,
                                                                                    uom_code: selectedResultData.uomCode,
                                                                                    checked: e.target.checked,
                                                                                },
                                                                            })}
                                                                            type="checkbox"
                                                                            checked={(ResultSectionsId && ResultSectionsId.indexOf(selectedResultData.serviceorder_id.toString()) != -1) ? true : false}
                                                                            className="custom-control-input"
                                                                            id={'customCheck' + selectedResultData.serviceorder_id}
                                                                        />
                                                                        <label className="custom-control-label" htmlFor={'customCheck' + selectedResultData.serviceorder_id}>{selectedResultData.component_name || null}</label>
                                                                    </div>
                                                                </td>
                                                                <td className={selectedResultData.isAbnormal?.toUpperCase() === 'P' ? 'text-danger' : selectedResultData.isAbnormal?.toUpperCase() === 'N' ? 'text-success' : 'text-dark font-weight-medium'}>{this.renderTestValue(selectedResultData)}</td>
                                                                <td>{selectedResultData.uomCode}</td>
                                                                <td style={{ whiteSpace: 'pre' }}>{(selectedResultData.reference_range || '').replaceAll('<br/>', '<br>').split('<br>').join('\r\n')}</td>
                                                            </tr>
                                                        ) : null)
                                                    ) : (
                                                        <tr><td><object width="100%" height="500" data={selectedResultData.result_link} type="application/pdf"> </object></td></tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    )}
                                    {selectedResultData.result_value_type.toUpperCase() == 'TEXT' ? (
                                        <div className="row mt-3">
                                            <div className="col-12 text-right">
                                                <Button
                                                    type="primary"
                                                    htmlType="button"
                                                    className="btn btn-primary"
                                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.existingResultsSave(); }}
                                                >
                                                    ADD TO ANC CARD
                                                </Button>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                    </Form>
                </Modal>
            </>
        );
    }
}

export default AncTestProcedures;
